import { useEffect, useState } from "react";
import Lenis from "lenis";
import Seo from "@/components/Seo";
import { setLenis } from "@/lib/lenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App bg-bergamote-50">
      <Seo
        title="La Bergamote - Restaurant & Salon de Thé"
        siteName="La Bergamote Genève"
        description="Persian restaurant and artisanal pâtisserie on Rue d'Enfer, Geneva. Pistachio cake, saffron dishes, teas from the Silk Road. Mon–Sat 10:00–19:00. 022 312 23 33."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CafeOrCoffeeShop",
          name: "La Bergamote Genève - Salon de thé",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Rue d'Enfer",
            postalCode: "1204",
            addressLocality: "Genève",
            addressCountry: "CH",
          },
          telephone: "+41223122333",
          url: "https://labergamote.ch",
          priceRange: "CHF 10–60",
          openingHours: "Mo-Sa 10:00-19:00",
          aggregateRating: { "@type": "AggregateRating", ratingValue: "4.5", reviewCount: "288" },
        }}
      />
      <div className="grain-overlay" aria-hidden />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Gallery />
        <Reviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
